import colors from '@/enum/colors'
import { computed } from 'vue'
import { activeLayoutColors } from '@/composables/globalData/useLayouts'
import { IAccountStatusItem } from '@/types/dashboard'

export const Statuses = {
    LOGIN: 1,
    LOGOUT: 2,
    LUNCH: 3,
    ADMINISTRATIVE: 5,
    PRIVATE: 7,
    OTHER: 9,
    TRAINING: 11,
    TEAM_MEETING: 12,
    BRIEF: 13,
    IN_CALL: 100,
    HOLD: 101,
    AT_WORK: 102,
    CALLING: 103
} as const

export const callStatuses = {
    IN_CALL: Statuses.IN_CALL,
    HOLD: Statuses.HOLD,
    CALLING: Statuses.CALLING
}

export const CounterWidgetsOnlyStatuses = {
    IN_CALL_OUTGOING: 5555,
    IN_CALL_INCOMING: 6666
} as const

export const DefaultCardCounterStatus = Statuses.LUNCH
export const HOLD_STATUS = 'hold'
export const otherStatuses = {
    AT_WORK: Statuses.AT_WORK,
}

export const statusNameLogOut = 'Log out'

export const statusCardsWithContentTitle = [ 5 ]

// from extensionStatuses
// administrative, training, team meeting, brief
export const administrativeStatuses = [ 5, 11, 12, 13 ]

// launch, other, private
export const breakStatuses = [ 3, 7, 9 ]

export function isStatusIsCallStatus (status: number) {
    return (Object.values(callStatuses) as number[]).includes(status)
}

// StatusTypes for new redesign components
const redesignStatusTypes = computed<Record<number, IAccountStatusItem>>(() => {
    const { inCall, onHold, inDialing } = activeLayoutColors.value

    return {
        [Statuses.LOGIN]: {
            icon: 'LogIn',
            color: colors.LOGIN_COLOR,
            text: 'status.login',
            value: Statuses.LOGIN
        },
        [Statuses.LOGOUT]: {
            icon: 'LogOut',
            color: colors.LOGOUT_COLOR,
            text: 'status.logout',
            value: Statuses.LOGOUT
        },
        [Statuses.LUNCH]: {
            icon: 'Utensils',
            color: colors.LUNCH_COLOR,
            text: 'status.lunch',
            value: Statuses.LUNCH
        },
        [Statuses.ADMINISTRATIVE]: {
            icon: 'Settings',
            color: colors.ADMINISTRATIVE_COLOR,
            text: 'status.administrative',
            value: Statuses.ADMINISTRATIVE
        },
        [Statuses.PRIVATE]: {
            icon: 'IconLockKeyhole',
            color: colors.PRIVATE_COLOR,
            text: 'status.private',
            value: Statuses.PRIVATE
        },
        [Statuses.OTHER]: {
            icon: 'IconEllipsis',
            color: colors.OTHER_COLOR,
            text: 'status.other',
            value: Statuses.OTHER
        },
        [Statuses.TRAINING]: {
            icon: 'GraduationCap',
            color: colors.TRAINING_COLOR,
            text: 'status.training',
            value: Statuses.TRAINING
        },
        [Statuses.TEAM_MEETING]: {
            icon: 'IconPresentation',
            color: colors.TEAM_MEETING_COLOR,
            text: 'status.teamMeeting',
            value: Statuses.TEAM_MEETING
        },
        [Statuses.BRIEF]: {
            icon: 'ClipboardList',
            color: colors.BRIEF_COLOR,
            text: 'status.brief',
            value: Statuses.BRIEF
        },
        [Statuses.IN_CALL]: {
            icon: 'PhoneCall',
            color: inCall,
            text: 'status.incall',
            value: Statuses.IN_CALL
        },
        [Statuses.HOLD]: {
            icon: 'Pause',
            color: onHold,
            text: 'status.hold',
            value: Statuses.HOLD
        },
        [Statuses.CALLING]: {
            icon: 'Phone',
            color: inDialing,
            text: 'status.calling',
            value: Statuses.CALLING
        },
        [Statuses.AT_WORK]: {
            icon: 'Briefcase',
            color: colors.LIGHT_GREEN,
            text: 'status.atWork',
            value: Statuses.AT_WORK
        }
    }
})

export default redesignStatusTypes

export const redesignStatusTypesWithCounterWidgets = computed<Record<number, IAccountStatusItem>>(() => {
    const { inCall } = activeLayoutColors.value

    return {
        ...redesignStatusTypes.value,
        [CounterWidgetsOnlyStatuses.IN_CALL_OUTGOING]: {
            icon: 'PhoneOutgoing',
            color: inCall,
            text: 'status.incallOutgoing',
            value: CounterWidgetsOnlyStatuses.IN_CALL_OUTGOING
        },
        [CounterWidgetsOnlyStatuses.IN_CALL_INCOMING]: {
            icon: 'PhoneIncoming',
            color: inCall,
            text: 'status.incallIncoming',
            value: CounterWidgetsOnlyStatuses.IN_CALL_INCOMING
        }
    }
})
